module.exports = __webpack_public_path__ + "static/media/bitterbal-vlag-korter@3x.39450157.webp";